module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "myaddress"
  }, [_c('div', {
    staticClass: "ipoint-payment-group"
  }, [_c('label', {
    staticClass: "profile-radio",
    on: {
      "click": function($event) {
        _vm.checkRadio(0, $event)
      }
    }
  }, [_c('span', {
    staticClass: "pro-radio",
    class: {
      'pro-radio-checked': _vm.tag == _vm.flag
    }
  }, [_c('span', {
    staticClass: "pro-radio-inner"
  }), _vm._v(" "), _c('input', {
    staticClass: "pro-radio-input",
    attrs: {
      "type": "radio"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "payment-group payment-group-paypal"
  }, [_c('div', {
    staticClass: "payment-desc"
  }, [_c('p', {
    staticClass: "pay-title",
    staticStyle: {
      "margin-top": "-10px"
    }
  }, [_vm._v(_vm._s(_vm.$t('delivery_address')))]), _vm._v(" "), _c('div', {
    staticClass: "address_box"
  }, [_c('ul', {
    staticClass: "address_now"
  }, _vm._l((_vm.addressGroup), function(tab, index) {
    return _c('li', {
      key: index,
      class: {
        active: tab.is_default === 1
      },
      on: {
        "click": function($event) {
          _vm.checkaddress(tab.address_id, $event)
        }
      }
    }, [_vm._v("\n                                " + _vm._s(tab.name) + "\n                                "), _c('p', [_vm._v(_vm._s(tab.mobile))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(tab.all_address))]), _vm._v(" "), _c('a', {
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          _vm.editAddress(index)
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('user_center_btn_modify')))])])
  }))]), _vm._v(" "), _c('button', {
    staticClass: "btn-primary btn-hollow",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.ShowAddress($event)
      }
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.$t('user_center_add_address')) + "\n                    ")])])])]), _vm._v(" "), _c('label', {
    staticClass: "profile-radio",
    staticStyle: {
      "padding": "35px 0 35px 0"
    },
    on: {
      "click": function($event) {
        _vm.checkRadio(1, $event)
      }
    }
  }, [_c('span', {
    staticClass: "pro-radio",
    class: {
      'pro-radio-checked': _vm.tag == !_vm.flag
    }
  }, [_c('span', {
    staticClass: "pro-radio-inner"
  }), _vm._v(" "), _c('input', {
    staticClass: "pro-radio-input",
    attrs: {
      "type": "radio"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "payment-group payment-group-paypal"
  }, [_c('div', {
    staticClass: "payment-desc"
  }, [_c('p', {
    staticClass: "pay-title",
    staticStyle: {
      "margin-top": "-10px"
    }
  }, [_vm._v(_vm._s(_vm.$t('user_order_pick_up')))]), _vm._v(" "), _c('p', {
    staticClass: "address_offline"
  }, [_vm._v(_vm._s(_vm.$t('user_order_pick_up_offline_store')))]), _vm._v(" "), (_vm.iSstore) ? _c('ul', {
    staticClass: "choose_store"
  }, _vm._l((_vm.storeList), function(item, index) {
    return _c('li', {
      key: index,
      class: {
        active: index == _vm.num
      },
      on: {
        "click": function($event) {
          _vm.checkstore(item.id, index, $event)
        }
      }
    }, [_c('p', {
      staticClass: "choose_store_title"
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), (_vm.isShowcontent == index) ? _c('div', {
      staticClass: "storeList_content"
    }, [_c('p', {
      staticClass: "choose_store_content"
    }, [_vm._v(_vm._s(item.address))]), _vm._v(" "), _c('p', {
      staticClass: "choose_store_content"
    }, [_vm._v(_vm._s(item.phone))])]) : _vm._e(), _vm._v(" "), _c('p', {
      staticClass: "choose_detail",
      on: {
        "click": function($event) {
          _vm.Showcontent(index, $event)
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('store_mainpage_details')) + " >")])])
  })) : _vm._e()])])])]), _vm._v(" "), _c('modal', {
    staticClass: "add_Address",
    attrs: {
      "title": _vm.$t('user_center_add_address_tittle')
    },
    model: {
      value: (_vm.addAddress),
      callback: function($$v) {
        _vm.addAddress = $$v
      },
      expression: "addAddress"
    }
  }, [(_vm.addAddressGroup.address_id !== null) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.addAddressGroup.address_id),
      expression: "addAddressGroup.address_id"
    }],
    attrs: {
      "type": "hidden"
    },
    domProps: {
      "value": (_vm.addAddressGroup.address_id)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.addAddressGroup, "address_id", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "addr_modal"
  }, [_c('p', {
    staticClass: "addr_modal_tips"
  }, [_vm._v(_vm._s(_vm.$t('user_center_Coupons_Use_tips')) + ": "), _c('span', [_vm._v("*")]), _vm._v(_vm._s(_vm.$t('add_address_must_item')))]), _vm._v(" "), _c('div', {
    staticClass: "addr_group"
  }, [_c('div', {
    staticClass: "addr_laber"
  }, [_vm._v("\n                    " + _vm._s(_vm.$t('add_address_area'))), _c('span', [_vm._v("*")])]), _vm._v(" "), _c('div', {
    staticClass: "addr_item1"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.addAddressGroup.country),
      expression: "addAddressGroup.country"
    }],
    attrs: {
      "name": "addAddressGroup_country"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.addAddressGroup, "country", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.countrys), function(item, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.country_name) + "\n                        ")])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "addr_group"
  }, [_c('div', {
    staticClass: "addr_laber"
  }, [_vm._v("\n                    " + _vm._s(_vm.$t('add_address_address'))), _c('span', [_vm._v("*")])]), _vm._v(" "), _c('div', {
    staticClass: "addr_item2"
  }, [_c('textarea', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.addAddressGroup.address),
      expression: "addAddressGroup.address"
    }],
    class: {
      'is-error': _vm.errors.has('addAddressGroup_address')
    },
    attrs: {
      "cols": "30",
      "rows": "6",
      "placeholder": _vm.$t('add_address_address_full'),
      "name": "addAddressGroup_address"
    },
    domProps: {
      "value": (_vm.addAddressGroup.address)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.addAddressGroup, "address", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "addr_group"
  }, [_c('div', {
    staticClass: "addr_laber"
  }, [_vm._v("\n                    " + _vm._s(_vm.$t('add_address_zip_code')) + "\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "addr_item1"
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|numeric'),
      expression: "'required|numeric'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.addAddressGroup.zipcode),
      expression: "addAddressGroup.zipcode"
    }],
    class: {
      'is-error': _vm.errors.has('addAddressGroup_zipcode')
    },
    attrs: {
      "type": "text",
      "name": "addAddressGroup_zipcode",
      "placeholder": _vm.$t('add_address_zip_code_full')
    },
    domProps: {
      "value": (_vm.addAddressGroup.zipcode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.addAddressGroup, "zipcode", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "addr_group"
  }, [_c('div', {
    staticClass: "addr_laber"
  }, [_vm._v("\n                    " + _vm._s(_vm.$t('about_ifree_join_sub_name'))), _c('span', [_vm._v("*")])]), _vm._v(" "), _c('div', {
    staticClass: "addr_item1"
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|min:1'),
      expression: "'required|min:1'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.addAddressGroup.name),
      expression: "addAddressGroup.name"
    }],
    class: {
      'is-error': _vm.errors.has('addAddressGroup_last_name')
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('add_address_first_name_full'),
      "name": "addAddressGroup_last_name"
    },
    domProps: {
      "value": (_vm.addAddressGroup.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.addAddressGroup, "name", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "addr_group"
  }, [_c('div', {
    staticClass: "addr_laber"
  }, [_vm._v("\n                    " + _vm._s(_vm.$t('about_ifree_join_sub_number'))), _c('span', [_vm._v("*")])]), _vm._v(" "), _c('div', {
    staticClass: "addr_item1"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.addAddressGroup.area_code),
      expression: "addAddressGroup.area_code"
    }],
    staticStyle: {
      "margin-bottom": "10px"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.addAddressGroup, "area_code", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.cityiso), function(item, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": item.area_code
      }
    }, [_vm._v("\n                            " + _vm._s(item.area_code) + " " + _vm._s(item.name) + "\n                        ")])
  })), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|min:11'),
      expression: "'required|min:11'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.addAddressGroup.mobile),
      expression: "addAddressGroup.mobile"
    }],
    staticClass: "form-input",
    class: {
      'is-error': _vm.errors.has('bind_phone')
    },
    attrs: {
      "name": "bind_phone",
      "type": "text",
      "placeholder": this.$t('add_number_number')
    },
    domProps: {
      "value": (_vm.addAddressGroup.mobile)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.addAddressGroup, "mobile", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "addr_group"
  }, [_c('div', {
    staticClass: "addr_laber"
  }), _vm._v(" "), _c('div', {
    staticClass: "addr_item1"
  }, [_c('Checkbox', {
    staticClass: "checkALL",
    staticStyle: {
      "font-size": "14px",
      "color": "#5E6D82"
    },
    on: {
      "on-change": _vm.check_default
    },
    model: {
      value: (_vm.default_single),
      callback: function($$v) {
        _vm.default_single = $$v
      },
      expression: "default_single"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.$t('add_address_defult_address')) + "\n                    ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "addr_group"
  }, [_c('div', {
    staticClass: "addr_laber"
  }), _vm._v(" "), _c('div', {
    staticClass: "addr_item1"
  }, [_c('button', {
    staticClass: "btn-pt btn-blue",
    on: {
      "click": _vm.saveAddress
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.$t('determine_btn')) + "\n                    ")])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  })])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-075f9870","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MyDetails/Common/Myaddress.vue
// module id = 778
// module chunks = 0